{
    "title": "Nastavení",
    "panel": {
      "createTitle": "Vytvořit {{title}}",
      "updateTitle": "Aktualizovat {{title}}",
      "createDescription": "Vytvořit {{title}}.",
      "updateDescription": "Aktualizovat {{title}}.",
      "removeTitle": "Odstranit {{title}}",
      "removeText": "Jste si jisti, že chcete odstranit tento {{title}}? Tato akce se nedá vrátit.",
      "closePanel": "Zavřít panel",
      "remove": "Odstranit",
      "test": "Test",
      "ok": "OK!",
      "error": "CHYBA",
      "cancel": "Zrušit",
      "create": "Vytvořit",
      "save": "Uložit"
    },
    "nav": {
      "application": "Aplikace",
      "logs": "Logy",
      "indexers": "Indexery",
      "irc": "IRC",
      "feeds": "Vlákna",
      "lists": "Listy",
      "clients": "Klienti",
      "notifications": "Notifikace",
      "apiKeys": "API klíče",
      "proxies": "Proxy",
      "releases": "Releasy",
      "account": "Účet"
    },
    "application": {
      "title": "Aplikace",
      "description": "Nastavení aplikace. Změňte v config.toml a pro použití restartujte.",
      "host": "Host",
      "port": "Port",
      "baseUrl": "Základní URL",
      "version": "Verze",
      "commit": "Commit",
      "buildDate": "Datum vytvoření",
      "application": "Aplikace",
      "configPath": "Lokalita konfiguračního souboru",
      "database": "Databáze",
      "webuiDebugMode": "WebUI Debugovací režim",
      "checkForUpdates": "Zkontrolovat aktualizace",
      "checkForUpdatesDescription": "Získávat notifikace o nových aktualizacích.",
      "theme": "Režim",
      "themeDescription": "Vyberte mezi světlým, tmavým nebo systémovým režimem.",
      "languageDescription": "Vyberte jazyk používaný ve WebUI.",
      "updateEnabled": "Budete obeznámeni o nových aktualizacích.",
      "updateDisabled": "Už nebudete obeznámeni o nových aktualizacích.",
      "updateAvailable": "{{name}} je dostupná!"
    },
    "account": {
      "title": "Účet",
      "description": "Spravovat nastavení účtu.",
      "required": "Povinné",
      "passwordsDoNotMatch": "Hesla se neshodují!",
      "updateSuccess": "Uživatel byl úspěšně aktualizován. Pro použití se přihlaste znovu!",
      "updateError": "Chyba při aktualizaci přihlašovacích údajů. Jste si jisti, že jste zadali správné aktuální heslo?",
      "changeCredentialsTitle": "Změnit přihlašovací údaje",
      "changeCredentialsDescription": "Uživatelské jméno a heslo lze změnit buď samostatně nebo dohromady. Nezpomeňte, že po změně přihlašovacích údajů budete odhlášeni.",
      "currentUsername": "Aktuální uživatelské jméno",
      "newUsername": "Nové uživatelské jméno",
      "optional": "Nepovinné",
      "currentPassword": "Aktuální heslo",
      "requiredIfUpdatingCredentials": "Povinné při aktualizaci přihlašovacích údajů",
      "newPassword": "Nové heslo",
      "confirmNewPassword": "Potvrdit nové heslo",
      "save": "Uložit",
      "identityProvider": "your identity provider",
      "oidcTitle": "OpenID Connect účet",
      "oidcDescription": "Přihlašovací údaje vašeho účtu jsou spravovány vaším OpenID Connect poskytovatelem. Chcete-li změnit své uživatelské jméno, navštivte stránku nastavení vašeho poskytovatele a přihlaste se znovu.",
      "authenticatedViaOidc": "Autentizováno přes OpenID Connect"
    },
    "logsPage": {
      "title": "Logy",
      "description": "Konfigurovat úroveň logování, rotaci velikosti logů atd. Můžete stáhnout své staré logovací soubory níže.",
      "chooseType": "Vyberte typ",
      "updated": "Konfigurace byla úspěšně aktualizována!",
      "path": "Lokalita",
      "setInConfig": "Nastaveno v config.toml",
      "notSet": "Nenastaveno!",
      "level": "Úroveň",
      "logLevel": "Úroveň logování",
      "maxSize": "Maximální velikost",
      "maxBackups": "Maximální počet záloh"
    },
    "regexPlayground": {
      "title": "Regex testování",
      "description": "Regex testování. Zde experimentujte s vašimi filtry. Nedokončená práce.",
      "regexFilter": "RegExp filtr",
      "linesToMatch": "Řádky k otestování",
      "matches": "Shody"
    },
    "apiKey": {
      "createTitle": "Vytvořit API klíč",
      "description": "Přidat nový API klíč.",
      "created": "API klíč {{name}} byl přidán",
      "deleted": "API klíč {{name}} byl odstraněn",
      "name": "Název",
      "key": "Klíč",
      "required": "Povinné",
      "closePanel": "Zavřít panel",
      "cancel": "Zrušit",
      "create": "Vytvořit",
      "listTitle": "API klíče",
      "listDescription": "Spravovat vaše autobrr API klíče zde.",
      "addNew": "Přidat nový",
      "noItems": "Žádné API klíče",
      "createCta": "Vytvořit API klíč",
      "removeTitle": "Odstranit API klíč: {{name}}",
      "removeText": "Jste si jisti, že chcete odstranit tento API klíč? Tato akce je nevratná.",
      "deleteKey": "Odstranit klíč"
    },
    "irc": {
      "listTitle": "IRC",
      "listDescription": "IRC sítě a kanály. Klikněte na síť pro zobrazení stavu kanálu.",
      "addNew": "Přidat nový",
      "networkHealthy": "Síť je v pořádku",
      "networkUnhealthy": "Síť je nedostupná",
      "networkDisabled": "Síť je vypnutá",
      "collapseTitle": "sbalit",
      "expandTitle": "rozbalit",
      "collapse": "Sbalit",
      "expand": "Rozbalit",
      "network": "Síť",
      "noNetworks": "Žádné sítě",
      "noNetworksSubtitle": "Obvykle nastaveno přes Indexery",
      "addNewNetwork": "Přidat novou síť",
      "toggleSuccess": "{{name}} byl úspěšně {{state}}.",
      "enabledState": "zapnut",
      "disabledState": "vypnut",
      "connectedSince": "Připojeno od: {{time}}",
      "tlsSecured": "Zabezpečeno pomocí TLS",
      "tlsInsecure": "Nezabezpečeno, nepoužívá TLS",
      "channel": "Kanál",
      "monitoringSince": "Monitorované od",
      "lastAnnounce": "Poslední oznámení",
      "monitoring": "monitorováno",
      "hide": "Skrýt",
      "view": "Zobrazit",
      "networkDeleted": "Síť {{name}} byla odstraněna",
      "networkRestarted": "{{name}} byla úspěšně restartována",
      "removeNetworkTitle": "Odstranit síť: {{name}}",
      "removeNetworkText": "Jste si jisti, že chcete odstranit tuto síť? Tato akce je nevratná.",
      "edit": "Upravit",
      "restart": "Restartovat",
      "delete": "Odstranit",
      "announceReprocessed": "Oznámení bylo opět úspěšně odesláno pro zpracování!",
      "reprocessAnnounce": "Opětovně zpracovat oznámení",
      "options": "Možnosti",
      "scrollOnNewMessage": "Posunout do spodní části při nové zprávě",
      "title": "Síť",
      "addWarning": "PŘIDÁVEJTE SÍTĚ POUZE PŘES INDEXERY! TOTO POUŽÍVEJTE JEN KDYŽ JSTE ODSTRANILI SÍTĚ",
      "added": "IRC síť byla přidána. Počkejte až 30 sekund, než se síť připojí.",
      "addFailed": "IRC síť nebyla přidána",
      "updated": "{{name}} byla úspěšně aktualizována",
      "deleted": "{{name}} byla odstraněna.",
      "required": "Povinné",
      "name": "Název",
      "enabled": "Zapnuto",
      "server": "Server",
      "serverPlaceholder": "Adresa: např. irc.server.net",
      "port": "Port",
      "portPlaceholder": "např. 6667",
      "tls": "TLS",
      "skipTls": "Přeskočit ověření TLS (nebezpečné)",
      "password": "Heslo",
      "passwordHelp": "Heslo sítě",
      "passwordUpdateHelp": "Heslo sítě, ne moc často používané.",
      "nick": "Přezdívka",
      "nickPlaceholderAdd": "přezdívka tvého bota",
      "nickPlaceholderUpdate": "přezdívka",
      "authAccount": "Autorizační účet",
      "authAccountPlaceholder": "Autorizační účet",
      "authPassword": "Autorizační heslo",
      "inviteCommand": "Příkaz pro pozvání do kanálu",
      "channels": "Kanály",
      "channelsDesc": "Kanály, které se mají připojit.",
      "channelsUpdateDesc": "Kanály jsou přidány, když nastavíte IRC indexery. Neupravujte, pokud nevíte, co děláte.",
      "channelPassword": "Heslo kanálu",
      "remove": "Odstranit",
      "noChannels": "Žádné kanály!",
      "addChannel": "Přidat kanál",
      "bouncer": "Bouncer (BNC)",
      "bouncerAddress": "Adresa bounceru",
      "bouncerAddressHelp": "Adresa: např. bouncer.server.net:6697",
      "botMode": "IRCv3 Bot režim",
      "proxy": "Proxy",
      "proxyDesc": "Nastavte proxy pro použití při připojování k IRC serveru.",
      "selectProxy": "Vybrat proxy",
      "selectProxyPlaceholder": "Vybrat proxy",
      "identification": "Identifikace",
      "identificationDesc": "Identifikujte se pomocí SASL nebo NickServ. Většina sítí podporuje SASL, ale některé ne.",
      "mechanism": "Mechanismus",
      "account": "Účet",
      "accountHelp": "NickServ / SASL účet. Pro skupinové nicky zkuste hlavní.",
      "passwordSaslHelp": "NickServ / SASL heslo.",
      "chooseType": "Vybrat typ"
    },
    "releases": {
      "warningTitle": "Varování:",
      "warningBody": "Tato sekce spravuje odstranění historie releasů. Automatické úklidy běží podle časového plánu, zatímco ruční odstranění umožňuje okamžité jednorázové čištění. Obě operace trvale odstraní data a nelze je vrátit.",
      "olderThan": "Starší než",
      "olderThanDesc": "Jak staré releasy musí být před odstraněním (Povinné pro obě automatické a ruční odstranění)",
      "indexers": "Indexery",
      "indexersDesc": "Volitelný filtr (pokud není vybrán, použije se na všechny indexery)",
      "releaseStatuses": "Stavy releasu",
      "releaseStatusesDesc": "Volitelný filtr (pokud není vybrán, použije se na všechny stavy releasu)",
      "duplicateProfilesTitle": "Duplikátní profily releasů",
      "duplicateProfilesDesc": "Spravovat duplikátní profily.",
      "cleanupJobsTitle": "Úklid releasů",
      "cleanupJobsDesc": "Plánovat automatické čištění starých releasů s vlastními filtry.",
      "addNew": "Přidat nový",
      "edit": "Upravit",
      "enabled": "Zapnuto",
      "name": "Název",
      "lastRun": "Poslední spuštění",
      "nextRun": "Další spuštění",
      "runNow": "Spustit nyní",
      "delete": "Odstranit",
      "never": "Nikdy",
      "deleteReleaseHistory": "Odstranit historii releasů",
      "deleteReleaseHistoryDesc": "Zde vyberte kritéria pro trvalé odstranění historie releasů, které jsou starší než vybrané období a případně i odpovídají vybraným indexerům a stavům releasu:",
      "removeReleases": "Odstranit releasy",
      "invalidAge": "Vyberte platné období.",
      "invalidAgeExample": "Vyberte platné období. Např. 6 měsíců nebo 1 rok.",
      "allDeleted": "Všechny releasy na základě kritérií byly odstraněny.",
      "olderThanDeleted": "Releasy starší než {{duration}} byly odstraněny.",
      "allIndexers": "všechny indexery",
      "selectedIndexers": "vybrané indexery",
      "removeCleanupJobTitle": "Odstranit úklid releasu: {{name}}",
      "removeCleanupJobText": "Jste si jisti, že chcete odstranit tento úklid releasu? Tato akce je nevratná.",
      "cleanupJobToggled": "{{name}} {{state}}",
      "cleanupJobTriggered": "{{name}} spuštěn",
      "cleanupJobDeleted": "{{name}} odstraněn",
      "cleanupJobEnabled": "zapnut",
      "cleanupJobDisabled": "vypnut",
      "duplicateFieldTitles": {
        "releaseName": "Název releasu",
        "hash": "Normalizovaný hash názvu releasu. Použijte s názvem releasu pro identické shody",
        "title": "Zanalyzovaný název",
        "subTitle": "Zanalyzovaný podnázev, jako např. název epizody",
        "group": "Skupina",
        "year": "Rok",
        "month": "Měsíc",
        "day": "Den",
        "source": "Zdroj",
        "resolution": "Rozlišení",
        "codec": "Kodek",
        "container": "Kontejner",
        "dynamicRange": "Dynamický rozsah (HDR,DV)",
        "audio": "Audio formáty",
        "season": "Sezóna",
        "episode": "Epizoda",
        "website": "Webová stránka/Služba",
        "proper": "Scénový proper",
        "repack": "Scénový repack",
        "edition": "Edice (např. Collectors Edition) a Cut (např. Directors Cut)",
        "language": "Jazyk a Region"
      },
      "noDuplicateProfiles": "Žádné duplikátní profily releasů",
      "addNewProfile": "Přidat nový profil releasu",
      "noCleanupJobs": "Žádné úklidy releasů",
      "createCleanupSchedules": "Vytvořit automatické úklidy releasů",
      "addNewJob": "Přidat nový úklid releasu",
      "removeReleasesText": "Právě jste {{scope}}.",
      "removeReleasesScopeAll": "odstranili všechny historické záznamy releasů pro {{indexers}}{{statuses}}",
      "removeReleasesScopeOlder": "trvale odstranili všechny historické záznamy releasů starších než {{duration}} pro {{indexers}}{{statuses}}",
      "removeReleasesStatuses": " a s následujícími stavy releasu: {{statuses}}",
      "duration": {
        "allTime": "všechny",
        "hour1": "1 hodina",
        "hours12": "12 hodin",
        "day1": "1 day",
        "week1": "1 týden",
        "month1": "1 měsíc",
        "months3": "3 měsíce",
        "months6": "6 měsíců",
        "year1": "1 rok",
        "invalid": "Neplatné období"
      }
    },
    "forms": {
      "downloadClient": {
        "remove": "Odstranit",
        "test": "Test",
        "ok": "OK!",
        "error": "CHYBA",
        "cancel": "Zrušit",
        "create": "Vytvořit",
        "save": "Uložit",
        "added": "Klient byl přidán",
        "addFailed": "Klient nebyl přidán",
        "updated": "{{name}} byl úspěšně aktualizován",
        "deleted": "{{name}} byl odstraněn.",
        "addTitle": "Přidat klienta",
        "addDescription": "Přidat klienta pro stahování.",
        "editTitle": "Upravit klienta",
        "editDescription": "Upravit nastavení klienta pro stahování.",
        "removeTitle": "Odstranit klienta",
        "removeText": "Jste si jisti, že chcete odstranit tohoto klienta? Tato akce je nevratná.",
        "closePanel": "Zavřít panel",
        "name": "Název",
        "enabled": "Zapnuto",
        "type": "Typ",
        "host": "Host",
        "port": "Port",
        "tls": "TLS",
        "skipTls": "Přeskočit ověření TLS (nebezpečné)",
        "username": "Uživatelské jméno",
        "password": "Heslo",
        "apiKey": "API klíč",
        "authToken": "Autorizační token",
        "basicAuth": "Basic autorizace",
        "auth": "Autorizace",
        "authType": "Typ autorizace",
        "selectAuthType": "Vybrat typ autorizace",
        "authTypeTooltip": "Většinou by to mělo být Basic Auth, ale některé poskytovatelé používají Digest Auth.",
        "hostHelpDeluge": "Např. klient.doména.ltd, doména.ltd/klient, doména.ltd:port",
        "hostHelpArr": "Kompletní URL http(s)://doména.ltd a/nebo subdoména/podsložka",
        "hostHelpQbit": "Např. http(s)://klient.doména.ltd, http(s)://doména.ltd/qbittorrent, http://doména.ltd:port",
        "hostHelpPorla": "Např. http(s)://klient.doména.ltd, http(s)://doména.ltd/porla, http://doména.ltd:port",
        "hostHelpAria2": "Např. http://localhost:6800, http(s)://doména.ltd/aria2",
        "rpcSecret": "RPC token",
        "rpcSecretHelp": "Hodnota --rpc-secret. Ponechte prázdné, pokud aria2 běží bez tokenu.",
        "hostHelpRTorrent": "Např. http(s)://klient.doména.ltd/RPC2, http(s)://doména.ltd/klient, http(s)://doména.ltd/RPC2",
        "hostHelpTransmission": "Např. http(s)://klient.doména.ltd, http(s)://doména.ltd/transmission",
        "hostHelpSabnzbd": "Např. http://ip:port or https://url.com/sabnzbd",
        "hostHelpNzbget": "Např. http://localhost:6789",
        "daemonPort": "Daemon port",
        "webUiPortQbit": "WebUI port pro qBittorrent",
        "transmissionPort": "Port pro Transmission",
        "sabnzbdPort": "port pro SABnzbd",
        "guidesDeluge": "Podívejte se na tutorialy jak se připojit k Deluge pro různé typy serverů v naší dokumentaci.",
        "guidesArr": "Podívejte se na tutorialy jak se připojit k *arr soupravě pro různé typy serverů v naší dokumentaci.",
        "guidesQbit": "Podívejte se na tutorialy jak se připojit k qBittorrentu pro různé typy serverů v naší dokumentaci.",
        "guidesRTorrent": "Podívejte se na tutorialy jak se připojit k rTorrentu pro různé typy serverů v naší dokumentaci.",
        "guidesTransmission": "Podívejte se na tutorialy jak se připojit k Transmission pro různé typy serverů v naší dokumentaci.",
        "guidesSabnzbd": "Podívejte se na tutorialy jak se připojit k SABnzbd pro různé typy serverů v naší dokumentaci.",
        "dedicatedServers": "Dedikované servery:",
        "sharedSeedboxProviders": "Poskytovatelé sdílených seedboxů:",
        "rulesTitle": "Pravidla",
        "rulesDescriptionBasic": "Spravovat max. počet stahování.",
        "rulesDescriptionAdvanced": "Spravovat max. počet stahování atd.",
        "maxActiveDownloads": "Max. aktivní stahování",
        "maxActiveDownloadsTooltip": "Omezit počet aktivních stahování (0 je neomezené), aby se získalo maximální množství rychlosti a disku pro stahování.",
        "seeRecommendations": "Podívejte se na doporučení pro různé typy serverů zde:",
        "downloadClientTitle": "Klient pro stahování",
        "downloadClientDescription": "Přepsat klienta pro stahování. Může být také přepsán pro každou akci filtru.",
        "clientName": "Název klienta",
        "clientNameTooltip": "Určit, který klient arr by měl být použit jako výchozí. Může být přepsán pro každou akci filtru.",
        "clientIdDeprecated": "ID klienta ZASTARALÉ",
        "clientIdDeprecatedTooltip": "ZASTARALÉ: Místo toho použijte pole Název klienta.",
        "ignoreSlowTorrents": "Ignorovat pomalé torrenty",
        "ignoreCondition": "Podmínka ignorování",
        "selectIgnoreCondition": "Vybrat podmínku ignorování",
        "ignoreConditionTooltip": "Vybrat, zda respektovat nebo ignorovat nastavení Max. aktivních stahování před kontrolou rychlostních limitů.",
        "downloadSpeedThreshold": "Limit rychlosti stahování",
        "uploadSpeedThreshold": "Limit rychlosti uploadu",
        "speedThresholdPlaceholder": "v KB/s",
        "downloadSpeedThresholdHelp": "Stáhnout vždy když je dosaženo max. aktivních stahování, pokud je rychlost stahování pod tímto prahem. KB/s",
        "uploadSpeedThresholdHelp": "Stáhnout vždy když je dosaženo max. aktivních stahování, pokud je rychlost uploadu pod tímto prahem. KB/s"
      },
      "feed": {
        "title": "Kanály",
        "updated": "{{name}} byl úspěšně aktualizován",
        "deleted": "{{name}} byl odstraněn.",
        "testOk": "{{name}} test OK!",
        "name": "Název",
        "type": "Typ",
        "enabled": "Zapnuto",
        "warningTitle": "Varování: Indexery vás mohou zabanovat za příliš krátký interval!",
        "warningText": "Přečtěte si pravidla indexeru.",
        "url": "URL",
        "torznabUrlHelp": "Torznab URL. Použijte pouze URL bez extra parametrů.",
        "newznabUrlHelp": "Newznab URL. Použijte pouze URL bez extra parametrů.",
        "rssUrlHelp": "RSS URL",
        "urlFormatTitle": "Prowlarr a Jackett mají jiné formáty:",
        "prowlarr": "Prowlarr",
        "jackett": "Jackett",
        "downloadType": "Typ stahování",
        "apiKey": "API klíč",
        "skipTls": "Přeskočit ověření TLS (nebezpečné)",
        "refreshInterval": "Interval obnovení",
        "refreshIntervalHelp": "Minuty. Doporučeno 15-30. Příliš nízké může znamenat ban.",
        "refreshTimeout": "Timeout obnovení",
        "refreshTimeoutHelp": "Čekat počet sekund před zrušením refreshnutí.",
        "maxAge": "Max. věk",
        "maxAgeHelp": "Maximální věk obsahu kanálu v sekundách. Použijte 0 k vypnutí filtru věku a zpracování všech položek.",
        "cacheTTL": "TTL mezipaměti",
        "cacheTTLHelp": "Počet dní, po které si autobrr pamatuje zpracované položky kanálu. Položky, které jsou v kanálu stále přítomny po vypršení, budou zpracovány a staženy znovu. Výchozí hodnota je 31 dní.",
        "cookie": "Cookie",
        "cookieHelp": "Ne často používané",
        "userAgent": "User-Agent",
        "userAgentHelp": "Vlastní User-Agent pro RSS požadavky. Použijte, když Cloudflare cookies vyžadují odpovídající User-Agent (např. z byparr)",
        "categoriesTitle": "Kategorie",
        "categoriesDescription": "Stáhnout dostupné kategorie a vybrat, co má být zahrnuto.",
        "fetch": "Stáhnout",
        "fetching": "Stahování",
        "refetch": "Obnovit",
        "fetchFailed": "Stáhnout kategorie",
        "noCategories": "Kategorie nebyly nalezeny.",
        "fetchToSelect": "Stáhnout kategorie pro výběr."
      },
      "list": {
        "added": "List byl přidán!",
        "addFailed": "List nebyl přidán",
        "updated": "{{name}} byl úspěšně aktualizován",
        "deleted": "{{name}} byl odstraněn.",
        "name": "Jméno",
        "type": "Typ",
        "enabled": "Zapnuto",
        "filters": "Filtry",
        "addTitle": "Přidat List",
        "updateTitle": "Aktualizovat List",
        "description": "Automatické aktualizace filtrů z listů a arrs.",
        "closePanel": "Zavřít panel",
        "chooseType": "Vybrat typ",
        "chooseClient": "Vybrat klienta",
        "selectClient": "Vybrat klienta",
        "selectClientLabel": "Vybrat klienta",
        "filtersDescription": "Vybrat filtry pro tento list, které mají být aktualizovány.",
        "cancel": "Zrušit",
        "remove": "Odstranit",
        "save": "Uložit",
        "saving": "Ukládání..",
        "selectSomeItems": "Vybrat...",
        "allItemsSelected": "Všechny položky jsou vybrány",
        "selectAll": "Vybrat vše",
        "search": "Hledat",
        "noOptions": "Žádné možnosti",
        "removeTitle": "Odstranit {{name}}",
        "removeText": "Jste si jisti, že chcete odstranit {{name}}? Tato akce je nevratná.",
        "required": "Povinné",
        "settingsLegend": "Nastavení",
        "source": "Zdroj",
        "sourceList": "Zdroj listu",
        "arrSourceDescription": "Aktualizovat filtry z titulů v Radarr, Sonarr, Lidarr, Readarr, nebo Whisparr.",
        "traktSourceDescription": "Použijte Trakt list nebo jeden z výchozích autobrr hostovaných listů.",
        "anilistSourceDescription": "Použijte AniList z jednoho z výchozích autobrr hostovaných listů.",
        "plaintextSourceDescription": "Použijte plain text list s jednou položkou na řádek.",
        "steamSourceDescription": "Sledovat Steam seznamy přání.",
        "metacriticSourceDescription": "Použijte Metacritic list nebo jeden z výchozích autobrr hostovaných listů.",
        "mdblistSourceDescription": "Použijte MDBList nebo jeden z výchozích autobrr hostovaných listů.",
        "listUrl": "List URL",
        "traktHelp": "Výchozí Trakt listy. Přepsat vlastními.",
        "traktApiKey": "API klíč",
        "traktApiKeyHelp": "Trakt API klíč. Vyžadován pro soukromé listy.",
        "matchRelease": "Podmínka shody releasu",
        "matchReleaseDesc": "Použijte pole Podmínka shody releasu. Ve výchozím stavu používá pole Filmy/Seriály.",
        "includeUnmonitored": "Zahrnout nemonitorované",
        "includeUnmonitoredDesc": "Ve výchozím stavu jsou filtrovány pouze sledované tituly.",
        "includeAlternateTitles": "Zahrnout alternativní tituly",
        "includeAlternateTitlesDesc": "Zahrnout alternativní tituly do filtru.",
        "skipCleanSanitize": "Přeskočit čištění a sanitizaci a použít seznam tak, jak je",
        "skipCleanSanitizeDesc": "Ve výchozím stavu jsou tituly automaticky čištěny a kontrolovány neobvyklé znaky.",
        "tagsIncluded": "Zahrnout tagy",
        "tagsExcluded": "Vyloučit tagy",
        "metacriticHelp": "Metacritic listy. Přepsat vlastními.",
        "mdblistHelp": "MDBLists.com listy. Přepsat vlastními.",
        "includeYear": "Zahrnout rok",
        "includeYearDesc": "Zahrnout rok vydání do filtru pro filmy. Vyžaduje Odpovídající releasy. Například: Movie?Title?2024*",
        "plaintextUrlHelp": "URL k obyčejnému textovému souboru s jednou položkou na řádek",
        "plaintextUrlPlaceholder": "https://example.com/list.txt",
        "plaintextTooltip1": "Obyčejné textové listy mohou být z HTTP URL a lokálních souborů na disku.",
        "plaintextTooltipRemote": "Vzdálený: https://service.com/file.txt",
        "plaintextTooltipLocal": "Lokální: file:///home/username/file.txt",
        "url": "URL",
        "steamUrlHelp": "Steam seznam přání URL",
        "steamUrlPlaceholder": "https://store.steampowered.com/wishlist/id/USERNAME/wishlistdata"
      },
      "proxy": {
        "title": "Proxy",
        "addTitle": "Přidat proxy",
        "addDescription": "Přidat proxy pro použití s Indexery nebo IRC.",
        "added": "Proxy byl přidán!",
        "addFailed": "Proxy nebyl přidán",
        "updated": "Proxy {{name}} byl úspěšně aktualizován!",
        "updateFailed": "Proxy nebyl úspěšně aktualizován",
        "deleted": "Proxy {{name}} byl odstraněn.",
        "name": "Jméno",
        "closePanel": "Zavřít panel",
        "enabled": "Zapnuto",
        "proxyType": "Typ proxy",
        "proxyTypeTooltip": "Typ proxy. Obvykle SOCKS5.",
        "proxyTypeHelp": "Obvykle SOCKS5",
        "addr": "Addr",
        "addrHelp": "Addr: scheme://ip:port nebo scheme://domain",
        "user": "Uživatel",
        "userHelp": "auth: uživatelské jméno",
        "pass": "Heslo",
        "passHelp": "auth: heslo",
        "test": "Testovat",
        "cancel": "Zrušit",
        "save": "Uložit"
      },
    "apiKey": {
      "createTitle": "Vytvořit API klíč",
      "description": "Přidat nový API klíč.",
      "created": "API klíč {{name}} byl přidán",
      "deleted": "API klíč {{name}} byl odstraněn",
      "name": "Jméno",
      "key": "Klíč",
      "required": "Povinné",
      "closePanel": "Zavřít panel",
      "cancel": "Zrušit",
      "create": "Vytvořit",
      "listTitle": "API klíče",
      "listDescription": "Správa vašich autobrr API klíčů.",
      "addNew": "Přidat nový",
      "noItems": "Žádné API klíče",
      "createCta": "Vytvořit API klíč",
      "removeTitle": "Odstranit API klíč: {{name}}",
      "removeText": "Jste si jisti, že chcete odstranit tento API klíč? Tato akce je nevratná.",
      "deleteKey": "Smazat klíč"
    },
      "notification": {
        "settings": "Nastavení",
        "settingsDescDiscordPrefix": "Vytvořit ",
        "settingsDescDiscordSuffix": " na tvém serveru.",
        "discordWebhookIntegration": "webhook integrace",
        "settingsDescNotifiarr": "Povolit integraci autobrr a případně vytvořit nový API klíč.",
        "settingsDescLunasea1": "LunaSea nabízí notifikace napříč všemi zařízeními spojenými s vaším účtem nebo na jedno zařízení bez účtu, používající unikátní webhook pro každé zařízení.",
        "settingsDescLunasea2Prefix": "Přečtěte si ",
        "settingsDescLunasea2Suffix": ".",
        "lunaseaDocs": "LunaSea dokumentaci",
        "settingsDescTelegramPrefix": "Přečtěte si, jak ",
        "settingsDescTelegramSuffix": ".",
        "createBot": "vytvořit bota",
        "settingsDescPushoverPrefix": "Registrovat nový ",
        "settingsDescPushoverSuffix": " a přidat sem jeho API Token.",
        "pushoverApplication": "aplikace",
        "eventSounds": "Zvuky událostí",
        "eventSoundsDesc": "Nastavit vlastní zvuky pro každou událost",
        "settingsDescWebhook": "Odeslat obecný autobrr JSON payload na uživatelem definovanou webhook URL adresu.",
        "added": "Notifikace byla přidána!",
        "addFailed": "Notifikace nemohla být přidána",
        "updated": "{{name}} byl úspěšně aktualizován",
        "deleted": "{{name}} byl odstraněn.",
        "required": "Povinné",
        "addTitle": "Přidat notifikace",
        "addDescription": "Aktivovat notifikace při různých událostech.",
        "title": "Notifikace",
        "name": "Jméno",
        "type": "Typ",
        "enabled": "Zapnuto",
        "chooseType": "Vybrat typ",
        "closePanel": "Zavřít panel",
        "globalEvents": "Globální události",
        "globalEventsDesc": "Vybrat výchozí události, které jsou aktivovány globálně. Tyto lze přepsat na základě filtru. Nezaškrtněte vše, aby se tato služba používala pouze pro notifikace specifické pro filtr.",
        "perFilterEvents": "Události podle filtru",
        "perFilterEventsDesc": "Tato notifikace je použita v těchto filtrech.",
        "notUsedInFilters": "Není použita v žádném filtru",
        "muted": "Ztlumeno",
        "test": "Test",
        "cancel": "Zrušit",
        "save": "Uložit",
        "notificationsLegend": "Notifikace",
        "defaultTone": "Výchozí (výchozí zvuk uživatele)",
        "webhookUrl": "Webhook URL adresa",
        "discordWebhookPlaceholder": "https://discordapp.com/api/webhooks/xx/xx",
        "discordWebhookHelp": "Webhook URL Discord kanálu",
        "notifiarrApiKey": "API klíč",
        "notifiarrApiKeyHelp": "Notifiarr API klíč",
        "lunaseaWebhookPlaceholder": "https://notify.lunasea.app/v1/custom/user/TOKEN",
        "lunaseaWebhookHelp": "Webhook URL LunaSea",
        "botToken": "Bot token",
        "botTokenHelp": "Bot token",
        "chatId": "Chat ID",
        "chatIdHelp": "Chat ID",
        "messageThreadId": "ID vlákna zpráv",
        "messageThreadIdHelp": "Vlákno zpráv (téma) superskupiny",
        "telegramProxy": "Telegram API Proxy",
        "telegramProxyHelp": "Reverzní proxy doména pro api.telegram.org. Potřeba pouze pokud vaše síť blokuje Telegram API.",
        "telegramProxyPlaceholder": "http(s)://ip:port",
        "sender": "Odesílatel",
        "senderHelp": "Vlastní název odesílatele zobrazený na začátku notifikace",
        "senderPlaceholder": "autobrr",
        "apiToken": "API klíč",
        "apiTokenHelp": "API klíč",
        "userKey": "Uživatelský klíč",
        "userKeyHelp": "Uživatelský klíč",
        "priority": "Priorita",
        "pushoverPriorityHelp": "-2, -1, 0 (výchozí), 1, or 2",
        "gotifyUrl": "Gotify URL adresa",
        "gotifyUrlHelp": "Gotify URL (bez /message)",
        "gotifyUrlPlaceholder": "https://some.gotify.server.com",
        "applicationToken": "Aplikační klíč",
        "applicationTokenHelp": "Aplikační klíč",
        "ntfyUrl": "NTFY URL adresa",
        "ntfyUrlHelp": "NTFY URL adresa",
        "ntfyUrlPlaceholder": "https://ntfy.sh/mytopic",
        "username": "Uživatelské jméno",
        "usernameHelp": "Uživatelské jméno",
        "password": "Heslo",
        "passwordHelp": "Heslo",
        "accessToken": "Přístupový klíč",
        "accessTokenHelp": "Přístupový klíč. Použijte tohle nebo Uživatelské jméno + heslo",
        "tags": "Tagy",
        "ntfyTagsHelp": "Tagy/ikony oddělené čárkami pro ntfy notifikace",
        "ntfyTagsPlaceholder": "download,arr,white_check_mark",
        "ntfyPriorityHelp": "Max 5, 4, 3 (výchozí), 2, 1 Min",
        "url": "URL",
        "urlHelp": "URL",
        "shoutrrrDocsPrefix": "Projděte si celou dokumentaci ",
        "shoutrrrServices": "Služby",
        "shoutrrrUrlPlaceholder": "smtp://username:password@host:port/?from=fromAddress&to=recipient1",
        "httpMethod": "HTTP Metoda",
        "httpMethodDefault": "POST (výchozí)",
        "httpMethodTooltip": "HTTP metoda pro webhook požadavek. Výchozí je POST.",
        "webhookPlaceholder": "https://example.com/webhook",
        "customHeaders": "Vlastní HTTP hlavičky",
        "customHeadersHelp": "Klíč=hodnoty oddělené čárkami (např. Authorization=Bearer token,X-Custom=hodnota)",
        "customHeadersPlaceholder": "Authorization=Bearer token,X-Custom-Header=hodnota"
      },
      "irc": {
        "listTitle": "IRC",
        "listDescription": "IRC sítě a kanály. Klikněte na síť pro zobrazení stavu kanálu.",
        "addNew": "Přidat nový",
        "networkHealthy": "Síť je v pořádku",
        "networkUnhealthy": "Síť je nedostupná",
        "networkDisabled": "Síť je vypnutá",
        "collapseTitle": "sbalit",
        "expandTitle": "rozbalit",
        "collapse": "Sbalit",
        "expand": "Rozbalit",
        "network": "Síť",
        "noNetworks": "Žádné sítě",
        "noNetworksSubtitle": "Obvykle nastaveno přes Indexery",
        "addNewNetwork": "Přidat novou síť",
        "toggleSuccess": "{{name}} byl {{state}} úspěšně.",
        "enabledState": "zapnut",
        "disabledState": "vypnut",
        "connectedSince": "Připojeno od: {{time}}",
        "tlsSecured": "Zabezpečeno pomocí TLS",
        "tlsInsecure": "Nezabezpečeno, nepoužívá TLS",
        "channel": "Kanál",
        "monitoringSince": "Monitorované od",
        "lastAnnounce": "Poslední oznámení",
        "monitoring": "monitorováno",
        "hide": "Skrýt",
        "view": "Zobrazit",
        "networkDeleted": "Síť {{name}} byla odstraněna",
        "networkRestarted": "{{name}} byla úspěšně restartována",
        "removeNetworkTitle": "Odstranit síť: {{name}}",
        "removeNetworkText": "Jste si jisti, že chcete odstranit tuto síť? Tato akce je nevratná.",
        "edit": "Editovat",
        "restart": "Restartovat",
        "delete": "Smazat",
        "announceReprocessed": "Oznámení bylo opět úspěšně odesláno pro zpracování!",
        "reprocessAnnounce": "Opětovně zpracovat oznámení",
        "options": "Možnosti",
        "scrollOnNewMessage": "Posunout dolů při nové zprávě",
        "title": "Síť",
        "addWarning": "PŘIDÁVEJTE SÍTĚ POUZE PŘES INDEXERY! TOTO POUŽÍVEJTE JEN KDYŽ JSTE ODSTRANILI SÍTĚ",
        "added": "IRC síť byla přidána. Počkejte až 30 sekund, než se síť připojí.",
        "addFailed": "IRC síť nebyla přidána",
        "updated": "{{name}} byla úspěšně aktualizována",
        "deleted": "{{name}} byla odstraněna.",
        "required": "Povinné",
        "name": "Název",
        "enabled": "Zapnuto",
        "server": "Server",
        "serverPlaceholder": "Adresa: např. irc.server.net",
        "port": "Port",
        "portPlaceholder": "např. 6667",
        "tls": "TLS",
        "skipTls": "Přeskočit ověření TLS (nebezpečné)",
        "password": "Heslo",
        "passwordHelp": "Heslo sítě",
        "passwordUpdateHelp": "Heslo sítě, moc často se nepoužívá.",
        "nick": "Přezdívka",
        "nickPlaceholderAdd": "přezdívka tvého bota",
        "nickPlaceholderUpdate": "přezdívka",
        "authAccount": "Autorizační účet",
        "authAccountPlaceholder": "Autorizační účet",
        "authPassword": "Autorizační heslo",
        "inviteCommand": "Příkaz pro pozvání do kanálu",
        "channels": "Kanály",
        "channelsDesc": "Kanály, které se mají připojit.",
        "channelsUpdateDesc": "Kanály jsou přidány, když nastavíte IRC indexery. Neupravujte, pokud nevíte, co děláte.",
        "channelPassword": "Heslo kanálu",
        "remove": "Odstranit",
        "noChannels": "Žádné kanály!",
        "addChannel": "Přidat kanál",
        "bouncer": "Bouncer (BNC)",
        "bouncerAddress": "Adresa bounceru",
        "bouncerAddressHelp": "Adresa: např. bouncer.server.net:6697",
        "botMode": "IRCv3 Bot Mode",
        "proxy": "Proxy",
        "proxyDesc": "Nastavte proxy pro použití při připojování k IRC serveru.",
        "selectProxy": "Vybrat proxy",
        "selectProxyPlaceholder": "Vybrat proxy",
        "identification": "Identifikace",
        "identificationDesc": "Identifikujte se pomocí SASL nebo NickServ. Většina sítí podporuje SASL, ale některé ne.",
        "mechanism": "Mechanismus",
        "account": "Účet",
        "accountHelp": "NickServ / SASL účet. Pro skupinové přezdívky zkuste hlavní účet.",
        "passwordSaslHelp": "NickServ / SASL heslo.",
        "chooseType": "Vybrat typ"
      },
      "indexer": {
        "title": "Indexer",
        "addTitle": "Přidat indexer",
        "addDescription": "Přidat indexer.",
        "added": "Indexer byl přidán",
        "addFailed": "Indexer nebyl přidán",
        "updated": "{{name}} byl úspěšně aktualizován",
        "deleted": "{{name}} byl odstraněn.",
        "indexer": "Indexer",
        "chooseIndexer": "Vybrat indexer",
        "required": "Povinné",
        "defaultValueValidation": "Výchozí hodnota, prosím upravte",
        "enabled": "Zapnuto",
        "baseUrl": "Základní URL",
        "baseUrlHelp": "Přepsat základní URL, pokud je blokována vaším poskytovatelem internetu.",
        "cancel": "Zrušit",
        "save": "Uložit",
        "closePanel": "Zavřít panel",
        "ircTitle": "IRC",
        "ircDesc": "Sítě a kanály jsou automaticky konfigurovány v pozadí.",
        "torznabTitle": "Torznab",
        "torznabDesc": "Torznab kanál",
        "newznabTitle": "Newznab",
        "newznabDesc": "Newznab kanál",
        "rssTitle": "RSS",
        "rssDesc": "RSS kanál",
        "settingsIrcTitle": "IRC",
        "settingsIrcDesc": "Sítě a kanály jsou automaticky konfigurovány v pozadí.",
        "ircGuideTooltip": "Projděte si naši IRC příručku, pokud neznáte IRC.",
        "name": "Název",
        "url": "URL",
        "torznabUrlHelp": "Torznab URL. Použijte pouze URL bez extra parametrů.",
        "newznabUrlHelp": "Newznab URL. Použijte pouze URL bez extra parametrů.",
        "urlFormatTitle": "Prowlarr a Jackett mají jiné formáty:",
        "prowlarr": "Prowlarr",
        "jackett": "Jackett",
        "apiKey": "API klíč",
        "downloadType": "Typ stahování",
        "downloadTypeTooltip": "Pro některé kanály je nutné vynutit použití Magnetu.",
        "downloadTypeHelp": "Nastavte na Torrent nebo Magnet v závislosti na indexeru.",
        "downloadTypeTooltip2": "Pro některé kanály je nutné vynutit použití Magnetu.",
        "categoriesTitle": "Kategorie",
        "categoriesDescription": "Stáhnout dostupné kategorie a vybrat, co má být zahrnuto.",
        "fetch": "Stáhnout",
        "fetching": "Stahování",
        "refetch": "Obnovit",
        "fetchFailed": "Stáhnout kategorie",
        "fetchNeedsUrl": "Zadejte URL pro stáhnutí kategorii",
        "noCategories": "Kategorie nebyly nalezeny.",
        "fetchToSelect": "Stáhnout kategorie pro výběr.",
        "testApi": "Test API",
        "testApiSuccess": "API test úspěšný!",
        "ok": "OK!",
        "error": "CHYBA",
        "externalIdentifier": "Externí identifikátor",
        "externalIdentifierHelp": "Externí identifikátor pro ARRs. Pokud používáte Prowlarr, nastavte jako: {{name}} (Prowlarr)",
        "externalIdentifierTooltip1": "Externí identifikátor pro použití s ARRs k získání funkcí jako jsou seed limity.",
        "externalIdentifierTooltip2": "Toto musí odpovídat názvu indexeru ve vašem ARR. Pokud používáte Prowlarr, bude to pravděpodobně \"{{name}} (Prowlarr)\"",
        "secretFieldTooltip": "Toto pole nepřijímá celou URL. Použijte pouze alfanumerické řetězce jako uqcdi67cibkx3an8cmdm.",
        "proxy": "Proxy",
        "proxyDesc": "Nastavte proxy pro použití při stahování .torrent souborů a kanálů.",
        "selectProxy": "Vybrat proxy",
        "selectProxyPlaceholder": "Vybrat proxy",
        "chooseType": "Vybrat typ",
        "editFeeds": "Upravit RSS kanály v Nastavení -> Kanály"
      },
      "releaseProfile": {
        "title": "Duplikátní profil",
        "added": "Profil byl přidán",
        "addFailed": "Profil nebyl přidán",
        "deleted": "Profil {{name}} byl odstraněn!",
        "fields": {
          "name": "Název",
          "releaseName": "Název releasu",
          "hash": "Hash",
          "title": "Název",
          "subTitle": "Podnázev",
          "year": "Rok",
          "month": "Měsíc",
          "day": "Den",
          "source": "Zdroj",
          "resolution": "Rozlišení",
          "codec": "Kodek",
          "container": "Kontejner",
          "dynamicRange": "Dynamický rozsah",
          "audio": "Audio",
          "group": "Skupina",
          "season": "Sezóna",
          "episode": "Epizoda",
          "website": "Webová stránka/Služba",
          "proper": "Scénový proper",
          "repack": "Scénový repack",
          "edition": "Edice",
          "hybrid": "Hybridní verze",
          "language": "Jazyk"
        },
        "descriptions": {
          "releaseName": "Plný název releasu",
          "hash": "Normalizovaný hash názvu releasu. Použijte s názvem releasu pro identické shody",
          "title": "Zdetekovaný název",
          "subTitle": "Zanalyzovaný podnázev, jako např. název epizody",
          "dailyReleases": "Pro denní releasy",
          "group": "Skupina",
          "website": "Služby jako AMZN/HULU/NF",
          "dynamicRange": "Dynamický rozsah (HDR,DV atd.)",
          "edition": "Edice a Cut",
          "language": "Jazyk a Region"
        }
      },
      "cleanupJob": {
        "title": "Úklid releasů",
        "created": "Úklid releasů byl vytvořen",
        "createFailed": "Úklid releasů nebyl vytvořen",
        "updated": "Úklid releasů byl aktualizován",
        "updateFailed": "Úklid releasů nebyl aktualizován",
        "deleted": "{{name}} byl odstraněn",
        "enableDesc": "Zapnout tento úklid releasů",
        "namePlaceholder": "Týdenní úklid",
        "schedule": "Plán (Cron)",
        "schedulePlaceholder": "0 3 * * *",
        "scheduleHelp": "Cron syntaxe. Příklady: '0 3 * * *' = denně 3 AM, '0 */6 * * *' = každých 6 hodin",
        "olderThan": "Starší než",
        "olderThanPlaceholder": "30",
        "olderThanHelp": "Odstranit releasy starší než tato doba",
        "indexersOptional": "Indexery (Volitelné)",
        "statusesOptional": "Stavy (Volitelné)",
        "leaveEmptyIndexers": "Ponechte prázdné pro použití na všech indexerech",
        "leaveEmptyStatuses": "Ponechte prázdné pro použití na všech statusech",
        "executionHistory": "Historie spuštění",
        "lastRun": "Poslední spuštění:",
        "status": "Stav:"
      }
    },
    "listScreens": {
      "common": {
        "enabled": "Zapnuto",
        "name": "Název",
        "type": "Typ",
        "edit": "Upravit",
        "addNew": "Přidat nový",
        "unknownError": "Neznámá chyba"
      },
      "downloadClients": {
        "title": "Stahovací klienti",
        "description": "Spravovat stahovací klienty.",
        "host": "Host",
        "noItems": "Žádní stahovací klienti",
        "addNewItem": "Přidat nový klient",
        "toggleSuccess": "{{name}} byl úspěšně {{state}} .",
        "enabledState": "zapnut",
        "disabledState": "vypnut"
      },
      "notifications": {
        "title": "Notifikace",
        "description": "Konfigurovat notifikační služby a jejich globální události.",
        "events": "Události",
        "filters": "Filtry",
        "noItems": "Žádné notifikace",
        "addNewItem": "Vytvořit novou notifikaci",
        "infoTitle": "Přepsání pro jednotlivé filtry:",
        "infoBody": "Tyto globální nastavení můžete přepsat pro konkrétní filtry v každém filtru na kartě Notifikace. Globální události jsou volitelné - můžete vytvořit notifikační služby bez žádných událostí a konfigurovat je pouze na úrovni filtru. Systémové události (IRC odpojen/připojen, aktualizace aplikace) vždy používají globální nastavení.",
        "toggleSuccess": "{{name}} byl úspěšně {{state}}.",
        "enabledState": "zapnut",
        "disabledState": "vypnut"
      },
      "indexers": {
        "title": "Indexery",
        "description": "Nastavení indexerů pro IRC, RSS, Newznab a Torznab.",
        "descriptionGeneric": "Generické RSS/Newznab/Torznab kanály lze přidat zde vybráním jednoho z <strong>Generických</strong> indexerů.",
        "implementation": "Implementace",
        "noItems": "Žádné indexery",
        "addNewItem": "Přidat nový indexer",
        "updated": "{{name}} byl úspěšně aktualizován",
        "deprecated": {
          "title": "Vyřazené indexery",
          "description": "Tyto indexery byly z autobrr odstraněny. Nelze je používat ani vybírat ve filtrech. Jejich releasy zůstávají zachovány a nadále zobrazují svůj název.",
          "removed": "Odstraněný indexer",
          "moreInfo": "Více informací",
          "usedByFilters_one": "Použito v {{count}} filtru",
          "usedByFilters_other": "Použito ve filtrech: {{count}}",
          "pruneAll": "Odebrat ze všech filtrů",
          "pruneOne": "Odebrat z filtrů",
          "pruneTitle": "Odebrat vyřazené indexery z filtrů",
          "pruneText": "Chcete opravdu odebrat všechny vyřazené indexery ze svých filtrů? Jejich releasy zůstanou zachovány, ale indexery již nebudou připojeny k žádnému filtru. Tuto akci nelze vrátit zpět.",
          "pruneOneTitle": "Odebrat {{name}} z filtrů",
          "pruneOneText": "Chcete opravdu odebrat {{name}} ze všech filtrů? Historické releasy a uložená data indexeru zůstanou zachovány.",
          "pruneSuccess_one": "Z filtrů bylo odebráno {{count}} připojení vyřazeného indexeru",
          "pruneSuccess_other": "Z filtrů bylo odebráno {{count}} připojení vyřazených indexerů",
          "pruneError": "Vyřazené indexery se nepodařilo odebrat z filtrů",
          "purge": "Smazat uložená data",
          "purgeTitle": "Smazat uložená data pro {{name}}",
          "purgeText": "Tímto trvale smažete uloženou konfiguraci a přihlašovací údaje indexeru. Historické releasy si zachovají čitelný název indexeru. Tuto akci nelze vrátit zpět.",
          "purgeSuccess": "Uložená data archivovaného indexeru byla smazána",
          "purgeError": "Uložená data archivovaného indexeru se nepodařilo smazat"
        }
      },
      "proxies": {
        "title": "Proxy servery",
        "description": "Proxy servery, které lze použít s indexery, kanály a IRC.",
        "noItems": "Žádné proxy servery",
        "addNewItem": "Přidat nový proxy server",
        "toggleSuccess": "Proxy {{name}} byl úspěšně {{state}}.",
        "toggleError": "Proxy server nebyl aktualizován",
        "enabledState": "zapnut",
        "disabledState": "vypnut"
      },
      "lists": {
        "title": "Listy",
        "description": "Listy mohou automaticky aktualizovat filtry z ARRů nebo jiných zdrojů.",
        "filters": "Filtry",
        "noItems": "Žádné listy",
        "addNewItem": "Přidat nový list",
        "toggleSuccess": "List {{name}} byl úspěšně {{state}}.",
        "toggleError": "List nebyl aktualizován",
        "refreshSuccess": "List {{name}} byl úspěšně stažen.",
        "refreshError": "List {{name}} nebyl aktualizován. Chyba: {{error}}",
        "deleted": "{{name}} byl odstraněn.",
        "removeTitle": "Odstranit list: {{name}}",
        "removeText": "Jste si jisti, že chcete odstranit tento list? Tato akce je nevratná.",
        "copyId": "Kopírovat List ID",
        "copyIdSuccess": "List ID {{id}} byl zkopírován do schránky.",
        "copyIdError": "ID listu se nepodařilo zkopírovat do schránky.",
        "refresh": "Aktualizovat",
        "delete": "Smazat",
        "enabledState": "zapnut",
        "disabledState": "vypnut"
      },
      "feeds": {
        "title": "Kanály",
        "description": "Spravovat RSS, Newznab a Torznab kanály.",
        "lastRun": "Poslední spuštění",
        "nextRun": "Další spuštění",
        "noItems": "Žádné kanály",
        "noItemsDesc": "Nastaveno přes indexery",
        "toggleSuccess": "{{name}} byl úspěšně {{state}}.",
        "enabledState": "zapnut",
        "disabledState": "vypnut",
        "deleted": "Kanál {{name}} byl odstraněn",
        "cacheCleared": "Kanál {{name}} byl vyprázdněn!",
        "forceRunSuccess": "Kanál {{name}} byl úspěšně spuštěn.",
        "forceRunError": "Kanál {{name}} nebyl úspěšně spuštěn. Chyba: {{error}}",
        "removeTitle": "Odstranit kanál: {{name}}",
        "removeText": "Jste si jisti, že chcete odstranit tento kanál? Tato akce je nevratná.",
        "removeCacheTitle": "Odstranit cache kanálu: {{name}}",
        "removeCacheText": "Jste si jisti, že chcete odstranit cache kanálu? Tato akce je nevratná.",
        "forceRunTitle": "Spustit kanál: {{name}}",
        "forceRunText": "Jste si jisti, že chcete spustit kanál {{name}}? Respektování pravidel intervalu RSS je důležité pro potenciální IP ban.",
        "toggle": "Přepnout",
        "forceRun": "Spustit kanál",
        "viewLatestRun": "Zobrazit poslední spuštění",
        "clearCache": "Vyprázdnit cache kanálu",
        "clearCacheTitle": "Vyprázdnit cache všech kanálů",
        "delete": "Smazat"
      }
    }
  }
